import { Editor, Element as SlateElement, Node, Range, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

import { TAG_REG } from '../constants';
import { CustomEditor, CustomElement, ITag } from '../types';
import { deserialize } from '../utils';

// 自定义编辑器配置
export const withMentions = (editor: CustomEditor) => {
  const { isInline, isVoid, normalizeNode } = editor;

  editor.isInline = (element: any) => {
    return element.type === 'mention' || isInline(element);
  };

  editor.isVoid = (element: any) => {
    return element.type === 'mention' || isVoid(element);
  };

  // 增加删除操作的处理
  const { deleteBackward } = editor;

  editor.deleteBackward = (unit) => {
    const { selection } = editor;

    if (selection && Range.isCollapsed(selection)) {
      // 如果光标在 mention 标签后面，则删除整个标签
      const prevNode = Editor.previous(editor);
      if (prevNode && SlateElement.isElement(prevNode[0]) && prevNode[0].type === 'mention') {
        Transforms.delete(editor, { unit, reverse: true });
        Transforms.move(editor);
        return;
      }
    }

    deleteBackward(unit);
  };

  editor.normalizeNode = ([node, path]) => {
    if (!SlateElement.isElement(node) || node.type === 'mention') {
      return normalizeNode([node, path]);
    }

    const text = Node.string(node);
    const matches = text.match(TAG_REG);

    if (!matches) {
      return normalizeNode([node, path]);
    }

    try {
      // 获取新的节点结构
      const newValue = deserialize(text)[0];

      // 检查是否需要更新
      const currentJson = JSON.stringify(node.children);
      const newJson = JSON.stringify(newValue.children);

      if (currentJson !== newJson) {
        // 执行转换
        Transforms.removeNodes(editor, { at: path });
        Transforms.insertNodes(editor, newValue, { at: path });
        return;
      }
    } catch (error) {
      console.error('Error in normalizeNode:', error);
    }

    normalizeNode([node, path]);
  };

  editor.insertMention = (tag: ITag) => {
    const { maxLength, currentValueRef } = editor || {};
    if (
      maxLength &&
      currentValueRef.current &&
      currentValueRef.current?.length + tag.value.length > maxLength
    ) {
      return;
    }
    const tagElement: CustomElement = {
      type: 'mention',
      tag,
      children: [{ text: '' }],
    };
    Transforms.insertNodes(editor, tagElement);
    Transforms.move(editor);
    ReactEditor.focus(editor);
  };

  return editor;
};
